import React from 'react';
import { get } from '../../Services/NetteApiClient';

export default function SearchWorkplaceResultOld(props) {
	const {
		workplace,
		linkSelect,
		handleClick = null,
		showArrow = true,
		showRemove = false,
	} = props;

	// @ts-ignore
	const onClick = async workplace => {
		if (handleClick) {
			handleClick(workplace);
		} else {
			const ajaxLink = linkSelect.replace('=null', '=' + workplace.id);
			await get(ajaxLink);
		}
	};

	return (
		<a
			onClick={() => onClick(workplace)}
			className='meddi-btn button-list__btn theme-gray mt-3'
			style={{ cursor: 'pointer' }}>
			<div className='button-list__btn__content'>{workplace.name}</div>
			{showArrow && (
				<div className='button-list__btn__arrow'>
					<img
						src='/dist/patientV3/icons/arrow-right-purple-small.svg'
						alt=''
					/>
				</div>
			)}
			{showRemove && (
				<div className='button-list__btn__arrow'>
					<img src='/dist/patientV3/icons/close-copy.svg' alt='' />
				</div>
			)}
		</a>
	);
}
